/* @ngInject */
function notificationsService (ConnectorWebService, CONSTANTS, Utils, RequestDeduplicationService) {
  var service = {
    getNotifications,
    getUnreadNotificationsCount,
    readNotification,
    readAllNotifications,
    deleteNotification,
    clearNewNotifications
  }

  return service

  function getNotifications (iTop, iSkip) {
    var sUrl = CONSTANTS.URL_USERS_NOTIFICATIONS

    if (iTop || iSkip) {
      sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
    }

    return ConnectorWebService.get(sUrl)
  }

  function getUnreadNotificationsCount () {
    const getUnreadNotificationsCountRequest = () => ConnectorWebService.get(CONSTANTS.URL_USERS_NOTIFICATIONS_UNREAD_COUNT)
    return RequestDeduplicationService.deduplicateRequest('NotificationsServiceGetUnreadNotificationsCount', getUnreadNotificationsCountRequest)
  }

  function readNotification (id) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_NOTIFICATIONS_ID, [id])
    return ConnectorWebService.put(sUrl)
  }

  function readAllNotifications () {
    return ConnectorWebService.put(CONSTANTS.URL_NOTIFICATIONS)
  }

  function deleteNotification (id) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_NOTIFICATIONS_ID, [id])
    return ConnectorWebService.fnDelete(sUrl)
  }

  function clearNewNotifications () {
    return ConnectorWebService.put(CONSTANTS.URL_NOTIFICATIONS_CLEAR_NEW)
  }
}

export { notificationsService }
